import { CommonModule } from '@angular/common'
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core'
import { GenericComponentsModule } from '@helios/generic-components'
import { SmartSuspensePanelComponent } from './smart-suspense-panel.component'

@NgModule({
  imports: [CommonModule, GenericComponentsModule],
  declarations: [SmartSuspensePanelComponent],
  exports: [SmartSuspensePanelComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SmartSuspenseModule {}

export { SmartSuspensePanelComponent }
